import axios from "axios";
import Config from "../../Config";

class AffiliateMarketingService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
      },
    };
  }

  async getPublishersPaginated(
    page = 1,
    limit = 15,
    search = "",
    sortBy = "",
    sortOrder = "asc",
    dateFrom = "",
    dateTo = "",
    network = ""
  ) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search }),
        ...(sortBy && { sort_by: sortBy }),
        ...(sortOrder && { sort_order: sortOrder }),
        ...(dateFrom && { date_from: dateFrom }),
        ...(dateTo && { date_to: dateTo }),
        ...(network && { network }),
      });

      const response = await axios.get(
        `${Config.baseUrl}/all_publishers?${params.toString()}`,
        this.getHeaders()
      );

      const root = response.data?.data ?? {};

      const normalizedData =
        root?.data?.data?.data ||
        root?.data?.data ||
        root?.data ||
        root?.data?.data?.publishers ||
        [];

      const data = Array.isArray(normalizedData) ? normalizedData : [];

      const pagination =
        root?.data?.pagination ||
        root?.data?.data?.pagination ||
        root?.pagination ||
        null;

      return {
        status: true,
        data,
        pagination,
        message: root.reason || "Publishers fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: [],
        pagination: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Failed to fetch publishers",
      };
    }
  }

  async getAllPublishers() {
    try {
      const response = await axios.get(
        `${Config.baseUrl}/all_publishers`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason || "Publishers fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Failed to fetch publishers",
      };
    }
  }

  async getMerchantsPaginated(
    page = 1,
    limit = 15,
    search = "",
    sortBy = "",
    sortOrder = "asc",
    dateFrom = "",
    dateTo = "",
    network = ""
  ) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search }),
        ...(sortBy && { sort_by: sortBy }),
        ...(sortOrder && { sort_order: sortOrder }),
        ...(dateFrom && { date_from: dateFrom }),
        ...(dateTo && { date_to: dateTo }),
        ...(network && { network }),
      });

      const response = await axios.get(
        `${Config.baseUrl}/all_merchants?${params.toString()}`,
        this.getHeaders()
      );

      const root = response.data?.data ?? {};

      const normalizedData =
        root?.data?.data?.data ||
        root?.data?.data ||
        root?.data ||
        root?.data?.data?.merchants ||
        [];

      const data = Array.isArray(normalizedData) ? normalizedData : [];

      const pagination =
        root?.data?.pagination ||
        root?.data?.data?.pagination ||
        root?.pagination ||
        null;

      return {
        status: true,
        data,
        pagination,
        message: root.reason || "Merchants fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: [],
        pagination: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Failed to fetch merchants",
      };
    }
  }

  async getAllMerchants() {
    try {
      const response = await axios.get(
        `${Config.baseUrl}/all_merchants`,
        this.getHeaders()
      );
      return {
        status: true,
        data: response.data.data,
        message: response.data.data.reason || "Merchants fetched successfully",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Failed to fetch merchants",
      };
    }
  }

  async requestAllPublishersExportToEmail() {
    try {
      const response = await axios.get(
        `${Config.baseUrl}/export_all_publishers`,
        this.getHeaders()
      );
      const root = response.data?.data ?? {};
      const statusCode = root?.status_code || root?.data?.status_code;
      const ok = statusCode ? statusCode === "000" : true;

      return {
        status: ok,
        message:
          root?.reason ||
          root?.data?.reason ||
          "Export request received. Please check your email shortly.",
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Failed to request email export",
      };
    }
  }

  async requestAllMerchantsExportToEmail() {
    try {
      const response = await axios.get(
        `${Config.baseUrl}/export_all_merchants`,
        this.getHeaders()
      );
      const root = response.data?.data ?? {};
      const statusCode = root?.status_code || root?.data?.status_code;
      const ok = statusCode ? statusCode === "000" : true;

      return {
        status: ok,
        message:
          root?.reason ||
          root?.data?.reason ||
          "Export request received. Please check your email shortly.",
      };
    } catch (error) {
      return {
        status: false,
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Failed to request email export",
      };
    }
  }
}

const affiliateMarketingService = new AffiliateMarketingService();
export default affiliateMarketingService;
